<template>
  <v-row>
    <v-col cols="7">
      <v-btn-toggle v-model="required" active-class="error white--text" multiple dense>
        <v-btn v-for="testType  in sampleTestTypes" :value="testType.uuid" small>{{testType.name}}</v-btn>
      </v-btn-toggle>
    </v-col>
    <v-col cols="4">
      <v-tooltip bottom>
        <template v-slot:activator="{on}">
          <v-btn v-on="on" :disabled="newRequirements.length === 0 || saving" @click="newRequirements = []" icon><v-icon>cancel</v-icon></v-btn>
        </template>
        <span>Cancel/Reset</span>
      </v-tooltip>
      <v-btn @click="save" :loading="saving" :disabled="newRequirements.length === 0 || saving" color="success" small>save</v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
    name: "RequiredTestButtons",
    components: {},
    props:{
      requirements: {
        required: true,
      },
      type_uuid: {
        required: true,
      }
    },
    computed:{
      sampleTestTypes(){
        return this.$store.$db().model('sampleTestTypes').all();
      },
      required:{
        get(){
          return this.newRequirements.length > 0 ? this.newRequirements : this.requirements.map(req => req.sample_test_type_uuid);
        },
        set(v){
          this.newRequirements = v;
        }
      }
    },
    data: () => ({
      newRequirements: [],
      saving: false,
    }),
    methods: {
      async save(){
        this.saving = true;
        let reqs = this.requirements.map(req => req.sample_test_type_uuid);
        let addRequirements = this.newRequirements.filter(req => !reqs.includes(req));
        let removeReqs = this.requirements.filter(req => !this.newRequirements.includes(req.sample_test_type_uuid));
        addRequirements = addRequirements.map(req => {
          return {
            uuid: null,
            sample_cert_type_uuid: this.type_uuid,
            sample_test_type_uuid: req,
            qty: 1,
            required: true,
            created_by: this.$store.getters.id,
            updated_by: this.$store.getters.id,
          }
        })
        // console.log(removeReqs, addRequirements)
        if(addRequirements.length > 0){
          let query = await this.$store.$db().model('sampleCertTypeTestRequirements').api().save({
            collection: addRequirements
          })
          console.log(query);
        }
        if(removeReqs.length > 0){
          for(let requirement of removeReqs){
            await this.$store.$db().model('sampleCertTypeTestRequirements').api().destroy(requirement.uuid, `Removed Requirement: ${requirement.test_type.name} from ${this.type_uuid}`)
          }
        }
        this.newRequirements = [];
        this.saving = false;
      }
    }
}
</script>

<style scoped>

</style>
